const isAsosAuthTimeoutError = error =>
  window.asos.sdk.identity.isAsosAuthTimeoutError(error);

export default isAsosAuthTimeoutError;
